import { ForgotPasswordTranslation } from '../../types/forgotPassword.types';

export const forgotPassword: ForgotPasswordTranslation = {
  title: 'Password Recovery',
  form: {
    emailPlaceholder: 'Enter your e-mail',
    emailLabel: 'E-MAIL',
    submit: 'SEND',
  },
  successMessage:
    'If the email provided is registered, you will receive a new password shortly. Use it to access the system.',
  backToLogin: 'Back to login',
};

export default forgotPassword;
